<script lang="ts">
  import type { IconValues } from '@gat-ship/icons'
  import type { GatRouteLocation, AppRoute } from '@gat-ship/lib/router'
  import { testIds } from '@gat-ship/types'

  export interface SectionHeaderProps {
    title: string
    description?: string
    icon?: IconValues
    backTo?: GatRouteLocation<AppRoute>
    titleTestId?: string
    descriptionTestId?: string
    hint?: string
  }
</script>

<script setup lang="ts">
  const props = defineProps<SectionHeaderProps>()
</script>

<template>
  <div class="flex min-h-16 flex-col gap-5">
    <header
      :class="[
        'flex flex-col gap-4 md:flex-row md:items-center md:justify-between md:gap-3'
      ]"
    >
      <slot name="header">
        <div class="flex flex-1 items-center gap-3">
          <div
            v-if="props.icon"
            class="shadow-xs ring-muted flex size-10 shrink-0 items-center justify-center rounded-md ring-1 ring-inset"
          >
            <gat-icon :icon="props.icon" class="text-soft size-5" />
          </div>
          <div>
            <slot name="title">
              <div class="flex items-baseline gap-1">
                <div
                  :class="['text-base font-medium leading-tight']"
                  :data-testid="props.titleTestId ?? testIds.common.page.title"
                >
                  {{ props.title }}
                </div>
                <tooltip-hint v-if="props.hint" :text="props.hint" />
              </div>
            </slot>
            <div
              v-if="props.description"
              class="text-soft mt-1 text-sm leading-none"
              :data-testid="
                props.descriptionTestId ?? testIds.common.page.description
              "
            >
              {{ props.description }}
            </div>
          </div>
        </div>
        <slot name="actions" />
      </slot>
    </header>
  </div>
</template>
